var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 336,
    viewBox: "0 0 42 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.9968V324.997",
    stroke: "#03565A",
    strokeOpacity: 0.52
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    fill: "#03565A",
    stroke: "#03565A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9176 13.4545H20.7798L17.1506 15.8267V17.929L20.6307 15.6562H20.7159V28H22.9176V13.4545Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 168,
    r: 20,
    fill: "#F0DBC8",
    stroke: "#03565A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3991 175H25.973V173.118H19.4247V173.011L22.3153 169.986C24.9787 167.294 25.7386 166.009 25.7386 164.382C25.7386 162.045 23.8352 160.256 21.0938 160.256C18.3736 160.256 16.3849 162.017 16.3849 164.673H18.4801C18.473 163.111 19.4815 162.088 21.0511 162.088C22.5284 162.088 23.6506 162.997 23.6506 164.446C23.6506 165.732 22.8835 166.655 21.321 168.31L16.3991 173.409V175Z",
    fill: "#03565A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 315,
    r: 20,
    fill: "#F0DBC8",
    stroke: "#03565A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4631 322.199C24.4318 322.199 26.6122 320.423 26.6051 318.009C26.6122 316.169 25.4972 314.848 23.5653 314.55V314.436C25.0852 314.045 26.0724 312.852 26.0653 311.219C26.0724 309.081 24.3182 307.256 21.5199 307.256C18.8494 307.256 16.7045 308.868 16.6335 311.233H18.7571C18.8068 309.898 20.0639 309.088 21.4915 309.088C22.9759 309.088 23.9489 309.99 23.9418 311.332C23.9489 312.739 22.8196 313.662 21.2074 313.662H19.9787V315.452H21.2074C23.2244 315.452 24.3892 316.474 24.3892 317.938C24.3892 319.351 23.1605 320.31 21.4489 320.31C19.8722 320.31 18.6435 319.5 18.5582 318.207H16.3281C16.4205 320.58 18.5227 322.199 21.4631 322.199Z",
    fill: "#03565A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 94.5,
    r: 4.5,
    fill: "#03565A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 241.5,
    r: 4.5,
    fill: "#03565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar1);
export default __webpack_public_path__ + "static/media/sidebar-1.01307e2ffd8607bc071998ad6691177d.svg";
export { ForwardRef as ReactComponent };